import {
	AdditiveGroupWithSelected,
	AdditiveGroupsCache,
	IProduct,
	IProductsCategory
} from '@/types/interfaces/menu';
import { ADDITIVE_STATUSES } from '@/types/enums/menu';
import type { ICartPosition } from '@/types/interfaces/cart';

export enum KEYS {
	CART = 'cart',
	TEMP_TERMINALS = 'tempTerminals',
	MENU_TEMP_DATA = 'menuTempData',
	TABLET_TEMP_DATA = 'tabletTempData'
}

export interface ICustomCategory {
	id: number;
	translateKey: string;
}

export interface ITempFilialData {
	source?: string;
	filialId?: number;
	brandId?: number;
	table:
		| {
				id: string;
				table_number?: number;
				section_name?: string;
				name: string;
		  }
		| undefined;
	kioskId?: string;
}

export interface IMenuState {
	menu: IProductsCategory[];
	externalId?: string;
	recentTerminalId: number;
	additiveGroupsCache: {
		[key in ADDITIVE_STATUSES]: AdditiveGroupsCache;
	};
}

export interface IMenuService {
	state: IMenuState;
	fetchMenu: (
		filialId: number,
		isAuthorized: boolean,
		force?: boolean,
		abort?: AbortController
	) => Promise<{
		categories: IProductsCategory[];
		externalId?: string;
	}>;
	getAdditiveGroups: (
		productId: number,
		status?: ADDITIVE_STATUSES
	) => AdditiveGroupWithSelected;
	fetchAdditiveGroups: (
		product: IProduct,
		filialId: number,
		serviceType: number,
		isAuthorized: boolean,
		status?: ADDITIVE_STATUSES
	) => Promise<AdditiveGroupWithSelected | undefined>;
	clearMenu: () => void;
	clearAdditiveGroups: () => void;
	fetchRecommendedProducts: (
		filialId: number,
		products: ICartPosition[]
	) => Promise<IProduct[]>;
}
